import React from 'react';
import './ProjectsPage.css';

function ProjectsPage() {
  return (
    <div className="projects-page">
      {/* Hero Section */}
      <section className="projects-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Our Projects</h1>
            <p className="hero-description">
              Showcasing our successful sports infrastructure projects across Rajasthan and beyond
            </p>
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      <section className="featured-projects">
        <div className="container">
          <h2 className="section-title">Featured Projects</h2>
          
          {/* Nainwa Stadium Project */}
          <div className="project-showcase nainwa-stadium">
            <div className="project-content">
              <div className="project-text">
                <h3 className="project-title">Nainwa Stadium Development</h3>
                <p className="project-description">
                  Discussing the drawing of Nainwa Stadium with Honorable Sports Minister of Rajasthan Shri Ashok Chandna Ji during their visit at Nainwa. Under their guidance and supervision, we have developed 3 multi-sports stadiums in Bundi region on turnkey basis.
                </p>
                <div className="project-details">
                  <div className="detail-item">
                    <span className="detail-label">Location:</span>
                    <span className="detail-value">Nainwa, Bundi Region, Rajasthan</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Type:</span>
                    <span className="detail-value">Multi-Sports Stadium</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Scope:</span>
                    <span className="detail-value">3 Stadiums on Turnkey Basis</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Client:</span>
                    <span className="detail-value">Rajasthan Government</span>
                  </div>
                </div>
                <div className="project-status">
                  <span className="status-badge completed">Completed</span>
                </div>
              </div>
              <div className="project-images">
                <div className="main-image">
                  <div className="image-placeholder planning-meeting">
                    <div className="image-overlay">
                      <h4>Planning & Design Meeting</h4>
                      <p>With Honorable Sports Minister</p>
                    </div>
                  </div>
                </div>
                <div className="secondary-images">
                  <div className="secondary-image">
                    <div className="image-placeholder site-visit">
                      <div className="image-overlay">
                        <h4>Site Visit</h4>
                      </div>
                    </div>
                  </div>
                  <div className="secondary-image">
                    <div className="image-placeholder construction">
                      <div className="image-overlay">
                        <h4>Construction Progress</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RAS Club Tennis Court Project */}
          <div className="project-showcase ras-club">
            <div className="project-content">
              <div className="project-images">
                <div className="main-image">
                  <div className="image-placeholder tennis-court">
                    <div className="image-overlay">
                      <h4>RAS Club Tennis Court</h4>
                      <p>Newly Constructed Facility</p>
                    </div>
                  </div>
                </div>
                <div className="secondary-images">
                  <div className="secondary-image">
                    <div className="image-placeholder inauguration">
                      <div className="image-overlay">
                        <h4>Inauguration Ceremony</h4>
                      </div>
                    </div>
                  </div>
                  <div className="secondary-image">
                    <div className="image-placeholder court-overview">
                      <div className="image-overlay">
                        <h4>Court Overview</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="project-text">
                <h3 className="project-title">RAS Club Tennis Court</h3>
                <p className="project-description">
                  Honorable Chief Minister of Rajasthan Shri Ashok Gehlot Ji visiting the newly constructed Tennis Court at RAS Club, Jaipur with Chief Secretary M/s. Usha Sharma Ji, Shri Govind Singh Dotasra Ji and Shri Pawan Arora Ji, Commissioner Raj. Housing Board and appreciating our work.
                </p>
                <div className="project-details">
                  <div className="detail-item">
                    <span className="detail-label">Location:</span>
                    <span className="detail-value">RAS Club, Jaipur, Rajasthan</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Type:</span>
                    <span className="detail-value">Tennis Court</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Surface:</span>
                    <span className="detail-value">Professional Tennis Surface</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Client:</span>
                    <span className="detail-value">RAS Club, Jaipur</span>
                  </div>
                </div>
                <div className="project-status">
                  <span className="status-badge completed">Completed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hours & Complete Projects Section */}
      <section className="hours-projects-section">
        <div className="container">
          <h2 className="section-title">Our Achievements</h2>
          <div className="achievements-grid">
            <div className="achievement-card">
              <div className="achievement-icon">⏰</div>
              <div className="achievement-content">
                <h3 className="achievement-title">Working Hours</h3>
                <div className="achievement-stats">
                  <div className="stat-item">
                    <span className="stat-number">50,000+</span>
                    <span className="stat-label">Hours Completed</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">24/7</span>
                    <span className="stat-label">Support Available</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="achievement-card">
              <div className="achievement-icon">🏆</div>
              <div className="achievement-content">
                <h3 className="achievement-title">Complete Projects</h3>
                <div className="achievement-stats">
                  <div className="stat-item">
                    <span className="stat-number">500+</span>
                    <span className="stat-label">Projects Delivered</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">100%</span>
                    <span className="stat-label">Success Rate</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="achievement-card">
              <div className="achievement-icon">🏟️</div>
              <div className="achievement-content">
                <h3 className="achievement-title">Sports Facilities</h3>
                <div className="achievement-stats">
                  <div className="stat-item">
                    <span className="stat-number">50+</span>
                    <span className="stat-label">Sports Types</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">20+</span>
                    <span className="stat-label">Years Experience</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="achievement-card">
              <div className="achievement-icon">👥</div>
              <div className="achievement-content">
                <h3 className="achievement-title">Client Satisfaction</h3>
                <div className="achievement-stats">
                  <div className="stat-item">
                    <span className="stat-number">1000+</span>
                    <span className="stat-label">Happy Clients</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">5★</span>
                    <span className="stat-label">Average Rating</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* All Projects Grid */}
      <section className="all-projects">
        <div className="container">
          <h2 className="section-title">All Projects</h2>
          <div className="projects-grid">
            <div className="project-card">
              <div className="project-image">
                <div className="image-placeholder basketball">
                  <div className="project-overlay">
                    <h4>Basketball Courts</h4>
                    <p>Multiple Locations</p>
                  </div>
                </div>
              </div>
              <div className="project-info">
                <h4 className="project-name">Basketball Facilities</h4>
                <p className="project-location">Various Locations</p>
                <span className="project-status-badge">Completed</span>
              </div>
            </div>
            
            <div className="project-card">
              <div className="project-image">
                <div className="image-placeholder tennis">
                  <div className="project-overlay">
                    <h4>Tennis Courts</h4>
                    <p>Professional Grade</p>
                  </div>
                </div>
              </div>
              <div className="project-info">
                <h4 className="project-name">Tennis Courts</h4>
                <p className="project-location">Multiple Sites</p>
                <span className="project-status-badge">Completed</span>
              </div>
            </div>
            
            <div className="project-card">
              <div className="project-image">
                <div className="image-placeholder football">
                  <div className="project-overlay">
                    <h4>Football Fields</h4>
                    <p>Full Size Fields</p>
                  </div>
                </div>
              </div>
              <div className="project-info">
                <h4 className="project-name">Football Fields</h4>
                <p className="project-location">Sports Complexes</p>
                <span className="project-status-badge">Completed</span>
              </div>
            </div>
            
            <div className="project-card">
              <div className="project-image">
                <div className="image-placeholder athletics">
                  <div className="project-overlay">
                    <h4>Athletics Track</h4>
                    <p>Olympic Standard</p>
                  </div>
                </div>
              </div>
              <div className="project-info">
                <h4 className="project-name">Athletics Tracks</h4>
                <p className="project-location">Stadium Complexes</p>
                <span className="project-status-badge">Completed</span>
              </div>
            </div>
            
            <div className="project-card">
              <div className="project-image">
                <div className="image-placeholder volleyball">
                  <div className="project-overlay">
                    <h4>Volleyball Courts</h4>
                    <p>Indoor & Outdoor</p>
                  </div>
                </div>
              </div>
              <div className="project-info">
                <h4 className="project-name">Volleyball Courts</h4>
                <p className="project-location">Sports Centers</p>
                <span className="project-status-badge">Completed</span>
              </div>
            </div>
            
            <div className="project-card">
              <div className="project-image">
                <div className="image-placeholder badminton">
                  <div className="project-overlay">
                    <h4>Badminton Courts</h4>
                    <p>Professional Setup</p>
                  </div>
                </div>
              </div>
              <div className="project-info">
                <h4 className="project-name">Badminton Courts</h4>
                <p className="project-location">Indoor Facilities</p>
                <span className="project-status-badge">Completed</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building. 
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <button className="view-more">View More...</button>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/" className="footer-link">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="/contact" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 123 Sports Avenue, Athletic District, City 12345</div>
                <div className="contact-item">📞 0123-456-789</div>
                <div className="contact-item">✉️ info@askmesportsalliance.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src="/assets/main logo.png" alt="Sports Alliance Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ELITE INTERNATIONAL SPORTS</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 Elite International Sports. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ProjectsPage;